// extracted by mini-css-extract-plugin
module.exports = {"checkButton":"checkButton--cPqkG"};